import { ICommand } from '@/modules/canvas/commands/ICommand';
import { HistoryServiceFactory } from '@/modules/canvas/services/history/HistoryServiceFactory';
import { IHistoryService } from '@/modules/canvas/services/history/IHistoryService';

import { OrderProfile } from '../types';
import { IOrderProfileService } from './IOrderProfileService';

export class OrderProfileServiceHistoryDecorator implements IOrderProfileService {
  private decoree: IOrderProfileService;
  private historySvc: IHistoryService;

  constructor(decoree: IOrderProfileService) {
    this.decoree = decoree;
    this.historySvc = HistoryServiceFactory.getInstance().createHistoryService();
  }

  getOrderProfile(): OrderProfile | null {
    return this.decoree.getOrderProfile();
  }

  setPanelOpen(value: boolean): void {
    this.decoree.setPanelOpen(value);
  }

  setOrderProfile(orderProfile: OrderProfile | null): void {
    const current = this.decoree.getOrderProfile();

    this.excuteAndTrack({
      execute: () => {
        this.decoree.setOrderProfile(orderProfile);
      },
      undo: () => {
        this.decoree.setOrderProfile(current);
      },
    });
  }

  //
  // Utility methods
  //

  private excuteAndTrack(command: ICommand) {
    command.execute();
    this.historySvc.track(command);
  }
}
